export const config = {
    setPreviewMode: "html-presentations/set-preview-mode"
}

export const slide = {
    switchTo: "html-presentations/slide/switch"
}

export const block = {
    click: "html-presentations/block-lessons/click"
}